/**
 * View Thread Button Component
 * Button to open message thread in RightPanel
 */

import React from 'react';
import { useAppStore } from '@/store/app.store';
import type { Message } from '@/types/api.types';

interface ViewThreadButtonProps {
  message: Message;
  replyCount?: number; // Optional reply count if available
}

export const ViewThreadButton: React.FC<ViewThreadButtonProps> = ({
  message,
  replyCount,
}) => {
  const { setActiveThreadMessage } = useAppStore();

  const handleViewThread = (e: React.MouseEvent) => {
    e.stopPropagation();
    setActiveThreadMessage(message.id);
  };

  return (
    <button
      onClick={handleViewThread}
      className="flex items-center space-x-1 px-2 py-1 text-xs font-medium text-blue-600 dark:text-blue-400 hover:bg-blue-50 dark:hover:bg-blue-900/20 rounded transition-colors"
      title="Покажи нишка"
    >
      <svg
        className="w-4 h-4"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
        />
      </svg>
      {replyCount !== undefined && replyCount > 0 && (
        <span>{replyCount} {replyCount === 1 ? 'отговор' : 'отговора'}</span>
      )}
      {(replyCount === undefined || replyCount === 0) && <span>Нишка</span>}
    </button>
  );
};

export default ViewThreadButton;
